import AsyncStorage from '@react-native-async-storage/async-storage';
import { jwtDecode } from 'jwt-decode';
import { ROUTES } from "../../../utilities/constant";
import { useNavigate } from 'react-router-dom'; // Assuming you're using React Router for navigation
import { toast } from "react-toastify";

const fallbackNavigate = (path) => {
    if (typeof window !== 'undefined' && window?.location) {
        window.location.assign(path);
    }
};

export const checkAuthSession = async ({
    navigate,
    setToastProps,
    setShowToast,
} = {}) => {
    try {
        const token = await AsyncStorage.getItem('access_token');
        if (!token) {
            throw new Error('Missing access_token');
        }

        const { exp } = jwtDecode(token);
        if (!exp || exp * 1000 < Date.now()) {
            await AsyncStorage.clear();
            throw new Error('Expired access_token');
        }

        return true;
    } catch (error) {
        console.log('Error decoding token:', error);
        errorCheck(error, navigate ?? fallbackNavigate, setToastProps, setShowToast);
        return false;
    }
};

export const useAuth = () => {
    const navigate = useNavigate();

    const checkAuth = async (setToastProps, setShowToast) => {
        await checkAuthSession({ navigate, setToastProps, setShowToast });
    };

    return { checkAuth };
};

export const errorCheck = (err, navigate, setToastProps, setShowToast) => {

    if (typeof navigate === 'function') {
        // setToastProps({ message: "Session Expired", type: "danger" });
                         toast.error("Session Expired");

        // setShowToast(true);

        AsyncStorage.clear()
            .then(() => {
                console.log('AsyncStorage cleared');
                setTimeout(() => {
                    navigate(`/${ROUTES.LOGIN}`);
                    if (typeof setShowToast === 'function') {
                        setShowToast(false);
                    }
                }, 1000);
            })
            .catch((error) => {
                console.error('Error clearing AsyncStorage:', error);
            });
    }
    toast.error(JSON.stringify(err));
};
